/**
 * Tip Component
 * Displays tips and alerts with different variants
 */

import React from 'react';

export type TipVariant = 'info' | 'success' | 'warning' | 'error';

export interface TipData {
  message: string;
  variant?: TipVariant;
  title?: string;
  icon?: string;
}

interface TipProps {
  tip: TipData;
}

const defaultIcons: Record<TipVariant, string> = {
  info: 'ℹ️',
  success: '✅',
  warning: '⚠️',
  error: '❌',
};

export const Tip: React.FC<TipProps> = ({ tip }) => {
  const { message, variant = 'info', title, icon } = tip;
  const displayIcon = icon || defaultIcons[variant];

  return (
    <div className={`ai360-tip ai360-tip-${variant}`}>
      <div className="ai360-tip-icon" role="img" aria-label={variant}>
        {displayIcon}
      </div>
      <div className="ai360-tip-content">
        {title && <strong className="ai360-tip-title">{title}</strong>}
        <div className="ai360-tip-message">{message}</div>
      </div>
    </div>
  );
};

interface TipsListProps {
  tips: TipData[];
}

export const TipsList: React.FC<TipsListProps> = ({ tips }) => {
  if (!tips || tips.length === 0) {
    return null;
  }

  return (
    <div className="ai360-tips-list">
      {tips.map((tip, index) => (
        <Tip key={index} tip={tip} />
      ))}
    </div>
  );
};
